<template>
  <div class="home-container">
    <div class="select-group">
      <div class="select-item" @click="showDatePicker">
        <label>选择日期</label>
        <div class="select-value">
          {{ selectedDate || '请选择计划' }}
          <i class="arrow"></i>
        </div>
      </div>
      <div class="select-item" @click="showPeriodPicker">
        <label>选择时间段</label>
        <div class="select-value" :class="{ disabled: !selectedBatch }">
          {{ selectedPeriodTime || '请选择时间段' }}
          <i class="arrow"></i>
        </div>
      </div>
    </div>
    <div class="button-group">
      <button @click="copyTitle">复制标题</button>
      <button @click="copyContent">复制内容</button>
      <button @click="copyCommunityName">复制社区名称</button>
      <button @click="downloadImages">批量下载图片</button>
      <button @click="publishContent">发布</button>
    </div>
    <div class="select-group" style="margin-top: 15px;">
      <div class="select-item" @click="showPhoneStatusPicker">
        <label>手机状态</label>
        <div class="select-value" :class="{ disabled: !selectedBatch }">
          {{ selectedStatus}}
          <i class="arrow"></i>
        </div>
      </div>
    </div>

    <!-- 日期选择弹窗 -->
    <van-popup
      v-model="showDatePickerPopup"
      position="bottom"
      round
    >
      <van-picker
        show-toolbar
        title="选择日期"
        :columns="dateList"
        @confirm="onDateConfirm"
        @cancel="showDatePickerPopup = false"
      />
    </van-popup>

    <!-- 时间段选择弹窗 -->
    <van-popup
      v-model="showPeriodPickerPopup"
      position="bottom"
      round
    >
      <van-picker
        show-toolbar
        title="选择时间段"
        :columns="currentPeriodList"
        @confirm="onPeriodConfirm"
        @cancel="showPeriodPickerPopup = false"
      />
    </van-popup>

    <!-- 状态值弹窗 -->
    <van-popup
      v-model="showPhoneStatusPopup"
      position="bottom"
      round
    >
      <van-picker
        show-toolbar
        title="手机状态"
        :columns="statusPopupList"
        @confirm="onStatusConfirm"
        @cancel="showPhoneStatusPopup = false"
      />
    </van-popup>
  </div>
</template>

<script>
import toast from '@/utils/toast'
import { commonApi } from '@/api'

export default {
  name: 'Home',
  data () {
    return {
      imageUrls: [],
      // 日期相关
      showDatePickerPopup: false,
      dateList: [],
      selectedDate: '',
      selectDateValue: '',
      // 时间相关
      showTimePickerPopup: false,
      timeColumns: ['09:00', '12:00', '15:00', '18:00', '21:00'],
      selectedBatchTime: '',
      selectedBatch: '',
      loading: false,
      dateBatch: {},
      currentBatchList: [],
      // 时间段相关
      showPeriodPickerPopup: false,
      batchPeriod: {},
      selectedPeriodTime: '',
      selectedPeriod: '',
      currentPeriodList: [],
      selectedStatus: '',
      statusPopupList: [
        {
          text: '关闭',
          value: 0
        },
        {
          text: '开启',
          value: 1
        },
        {
          text: '营销停用',
          value: 2
        }
      ],
      currentDataCopy: [],
      chooseContentId: '',
      showPhoneStatusPopup: false
    }
  },
  methods: {
    // 获取日期列表
    async fetchDateList () {
      try {
        this.loading = true
        // 调用接口获取日期列表
        const res = await commonApi.getPhoneContent({}, { Authorization: localStorage.getItem('token') })
        this.selectedStatus = this.statusPopupList[res.phoneStatus].text
        const data = res.relationList
        for (let i = 0; i < data.length; i++) {
          this.dateList.push({
            text: data[i].taskName,
            value: data[i].taskId
          })
          // 处理时间段数据
          const periodKey = `${data[i].taskId}`
          if (this.batchPeriod[periodKey] !== undefined) {
            this.batchPeriod[periodKey].push({
              text: data[i].batchTime,
              value: data[i].batchTimeId
            })
          } else {
            this.batchPeriod[periodKey] = [{
              text: data[i].batchTime,
              value: data[i].batchTimeId
            }]
          }
          const dataKey = `${data[i].taskId}_${data[i].batchTimeId}`
          this.currentDataCopy[dataKey] = data[i]
        }
        this.saveBatchData()
      } catch (error) {
        toast.error('获取日期列表失败')
        console.error('获取日期列表错误：', error)
      } finally {
        this.loading = false
      }
    },
    async publishContent () {
      const res = await commonApi.publishContent({ id: this.chooseContentId }, { Authorization: localStorage.getItem('token') })
      if (res) {
        toast.success('发布成功')
        // 刷新当前页面
        this.$router.go(0)
      } else {
        toast.error('发布失败')
      }
    },
    // 显示日期选择器
    showDatePicker () {
      if (this.loading) {
        toast.error('正在加载任务计划列表，请稍候')
        return
      }
      if (this.dateList.length === 0) {
        toast.error('暂无任务计划可选')
        return
      }
      this.showDatePickerPopup = true
    },
    // 确认日期选择
    onDateConfirm (value) {
      this.selectedDate = value.text
      this.selectDateValue = value.value
      this.showDatePickerPopup = false
      this.currentPeriodList = this.batchPeriod[value.value]
    },
    async copyTitle () {
      if (!this.selectedDate || !this.selectedPeriod) {
        toast.error('请先选择日期和时间段')
        return
      }
      const realKey = `${this.selectDateValue}_${this.selectedPeriod}`
      const title = this.currentDataCopy[realKey].title
      try {
        await navigator.clipboard.writeText(title)
        toast.success('标题已复制到剪贴板')
      } catch (err) {
        toast.error('复制失败，请重试')
      }
    },
    async copyCommunityName () {
      if (!this.selectedDate || !this.selectedPeriod) {
        toast.error('请先选择日期和时间段')
        return
      }
      const realKey = `${this.selectDateValue}_${this.selectedPeriod}`
      const title = this.currentDataCopy[realKey].communityName
      try {
        await navigator.clipboard.writeText(title)
        toast.success('标题已复制到剪贴板')
      } catch (err) {
        toast.error('复制失败，请重试')
      }
    },
    async copyContent () {
      if (!this.selectedDate || !this.selectedPeriod) {
        toast.error('请先选择日期和时间段')
        return
      }
      try {
        const realKey = `${this.selectDateValue}_${this.selectedPeriod}`
        const content = this.currentDataCopy[realKey].content
        await navigator.clipboard.writeText(content)
        toast.success('内容已复制到剪贴板')
      } catch (err) {
        toast.error('复制失败，请重试')
      }
    },
    downloadImages () {
      if (!this.selectedDate || !this.selectedPeriod) {
        toast.error('请先选择日期和时间段')
        return
      }

      const realKey = `${this.selectDateValue}_${this.selectedPeriod}`
      const imgList = this.currentDataCopy[realKey].imgList

      // 检查是否在微信浏览器内
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        toast.error('请点击右上角菜单，选择"在浏览器打开"后再下载图片')
        return
      }

      // 添加下载状态提示
      toast.success(`开始下载 ${imgList.length} 张图片`, { autoClose: 2000 })

      // 使用优化后的批量下载方法
      this.downloadImagesForAndroid(imgList)
        .then(() => {
          toast.success('所有图片下载完成')
        })
        .catch(error => {
          console.error('下载失败:', error)
          toast.error(`下载失败: ${error.message}`)
        })
    },
    // 修改后的下载方法（添加具体路径和提示）
    async androidDownloadFile (url, filename) {
      return new Promise((resolve, reject) => {
        fetch(url)
          .then(response => {
            if (!response.ok) throw new Error(`HTTP错误: ${response.status}`)
            return response.blob()
          })
          .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = blobUrl

            // 改进文件名：添加时间戳避免冲突
            const timestamp = new Date().getTime()
            const finalFilename = `myapp_${timestamp}_${filename}`
            link.download = finalFilename

            // 添加下载完成事件监听（部分浏览器支持）
            link.addEventListener('click', () => {
              toast.success(`图片将保存到: Download/${finalFilename}`)
            })

            document.body.appendChild(link)
            link.click()

            // 延迟清理
            setTimeout(() => {
              document.body.removeChild(link)
              window.URL.revokeObjectURL(blobUrl)

              // 在控制台输出保存路径
              console.log(`图片已保存: Download/${finalFilename}`)
              resolve(true)
            }, 1000)
          })
          .catch(error => {
            console.error('下载失败:', error)
            reject(error)
          })
      })
    },
    // 安卓专用批量下载方法
    async downloadImagesForAndroid (imgList) {
      // 创建下载目录（安卓特定）
      if (window.isAndroidApp) {
        await this.createAndroidDownloadDir()
      }

      // 添加进度跟踪
      let successCount = 0
      const totalCount = imgList.length

      // 更新进度函数
      const updateProgress = () => {
        toast.success(`下载进度: ${successCount}/${totalCount}`, { autoClose: 1000 })
      }

      for (let i = 0; i < imgList.length; i++) {
        const url = imgList[i]
        const filename = `image-${this.selectDateValue}_${this.selectedPeriod}_${i + 1}.jpg`

        try {
          // 使用安卓优化下载方法
          const result = await this.androidDownloadFile(url, filename)
          if (result) {
            successCount++
            updateProgress()
          }

          // 添加延迟防止浏览器阻塞
          await new Promise(resolve => setTimeout(resolve, 500))
        } catch (error) {
          console.error(`下载第 ${i + 1} 张图片失败:`, error)
          // 继续下载其他图片
        }
      }
    },

    // 创建安卓下载目录（可选）
    createAndroidDownloadDir () {
      return new Promise((resolve) => {
        if (window.AndroidFileSystem) {
          window.AndroidFileSystem.createDir('MyAppDownloads')
            .then(resolve)
            .catch(() => resolve())
        } else {
          resolve()
        }
      })
    },
    // 显示时间段选择器
    showPeriodPicker () {
      if (!this.selectedDate) {
        toast.error('请先选择任务计划')
        return
      }
      this.showPeriodPickerPopup = true
    },
    showPhoneStatusPicker () {
      this.showPhoneStatusPopup = true
    },
    // 确认时间段选择
    onPeriodConfirm (value) {
      console.log(value)
      this.selectedPeriodTime = value.text
      this.selectedPeriod = value.value
      this.showPeriodPickerPopup = false
      const realKey = `${this.selectDateValue}_${this.selectedPeriod}`
      this.chooseContentId = this.currentDataCopy[realKey].contentId
    },
    async onStatusConfirm (value) {
      this.selectedStatus = value.text

      const res = await commonApi.changePhoneStatus({
        isOpen: value.value
      }, { Authorization: localStorage.getItem('token') })
      if (res) {
        toast.success('修改成功')
        this.showPhoneStatusPopup = false
      } else {
        toast.error('修改失败')
      }
    },
    // 统一去重
    saveBatchData () {
      // 日期去重
      this.dateList = this.dateList.filter((item, index, self) =>
        index === self.findIndex(t => t.value === item.value)
      )
      // 时间段去重
      Object.keys(this.batchPeriod).forEach(batchId => {
        this.batchPeriod[batchId] = this.batchPeriod[batchId].filter((item, index, self) =>
          index === self.findIndex(t => t.value === item.value)
        )
      })
    }
  },
  created () {
    this.fetchDateList()
  }
}
</script>

<style lang="scss" scoped>
.home-container {
  padding: 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f5f5;

  .select-group {
    width: 90%;
    max-width: 600px;
    margin-bottom: 30px;

    .select-item {
      margin-bottom: 15px;
      background: #fff;
      border-radius: 8px;
      padding: 12px 15px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      label {
        display: block;
        margin-bottom: 8px;
        color: #666;
        font-size: 14px;
      }

      .select-value {
        position: relative;
        color: #333;
        font-size: 16px;
        padding-right: 20px;

        &.disabled {
          color: #999;
        }

        .arrow {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 8px;
          height: 8px;
          border-right: 2px solid #999;
          border-bottom: 2px solid #999;
          transform: translateY(-50%) rotate(45deg);
        }
      }
    }
  }

  .button-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 90%;
    max-width: 600px;

    button {
      padding: 15px 0;
      border: none;
      border-radius: 8px;
      background-color: #409eff;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s;
      box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);

      &:hover:not(:disabled) {
        background-color: #66b1ff;
      }

      &:disabled {
        background-color: #a0cfff;
        cursor: not-allowed;
      }
    }
  }
}

// 自定义 vant 组件样式
:deep(.van-popup) {
  max-height: 70vh;
  display: flex;
  flex-direction: column;
}

:deep(.van-picker) {
  flex: 1;
  display: flex;
  flex-direction: column;

  .van-picker__toolbar {
    background-color: #f7f8fa;
    flex-shrink: 0;
  }

  .van-picker__confirm {
    color: #409eff;
  }

  .van-picker__cancel {
    color: #666;
  }

  .van-picker-columns {
    flex: 1;
    overflow: hidden;
  }

  .van-picker-column {
    max-height: 250px;
  }
}
</style>
